import React, { useState, useEffect } from "react";
import Box from "@material-ui/core/Box";
import Alert from "@material-ui/lab/Alert";
import AuthForm from "./AuthForm";
import { useRouter } from "../util/router";
import { useAuth } from "../util/auth";

function Auth(props) {
  const router = useRouter();
  const auth = useAuth();
  const [formAlert, setFormAlert] = useState(null);
  const displayAlert = formAlert || (auth.authError && { type: "error", message: auth.authError });

  // Load pending signup from Firestore if user refreshes or navigates away
  useEffect(() => {
    const checkPending = async () => {
      if (!auth.user) return;
    };
    checkPending();
  }, [auth.user]);

  const handleFormAlert = (data) => setFormAlert(data);

  const handleAuth = async (data) => { 
    router.push(props.afterAuthPath);
  };
  
  return (
    <>
    
      <h1 style={{textAlign: 'center'}}>{props.title}</h1>
      {props.type === 'forgotpass' && <h3 style={{textTransform: 'uppercase', fontWeight: 'bold', color: '#ffd600ff'}}>*Please check your spam folder if you do not see the email in your inbox.</h3>}
      <AuthForm
        type={props.type}
        buttonAction={props.buttonAction}
        onAuth={handleAuth}
        onFormAlert={handleFormAlert}
      />
      
    {displayAlert && <div style={{marginTop: 15}}><Alert severity={displayAlert.type}>{displayAlert.message}</Alert></div>}


      {/* Optional: social auth */}
      {/* {["signup", "signin"].includes(props.type) && props.providers && props.providers.length > 0 && (
        <>
          <Box textAlign="center" fontSize={12} my={2}>OR</Box>
          <AuthSocial
            buttonAction={props.buttonAction}
            providers={props.providers}
            showLastUsed={true}
            onAuth={handleAuth}
            onError={(message) => handleFormAlert({ type: "error", message })}
          />
        </>
      )} */}
    </>
  );
}

export default Auth;
